import ScalarIconGlobeSimple_vue_vue_type_script_setup_true_lang_default from "./ScalarIconGlobeSimple.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconGlobeSimple.vue
var ScalarIconGlobeSimple_default = ScalarIconGlobeSimple_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconGlobeSimple_default as default };

//# sourceMappingURL=ScalarIconGlobeSimple.js.map